import { TaskApiResponse, Task } from '@/apis/tasks/types/tasksApi';
import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';

export const taskFromApiAdapter = (task: TaskApiResponse): Task => {
  return {
    outageID: task.outage_id,
    taskNumber: task.tasknumber,
    description: task.description,
  };
};

export const outageTasksFromApiAdapter = (
  response: PaginatedResponseFromApi<TaskApiResponse>,
): PaginatedResponse<Task> => {
  return {
    results: response?.results.map(taskFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};
